'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _commonMessageFormatGetters = require('../../common-message-format/operators/commonMessageFormatGetters');

var _threadGetters = require('../../thread/operators/threadGetters');

var _KeyPaths = require('../../thread/constants/KeyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLastActiveAt = function getLastActiveAt(conversation) {
  return (0, _commonMessageFormatGetters.getTimestamp)((0, _threadGetters.getLatestMessage)(conversation)) || (0, _getIn2.default)(_KeyPaths.LATEST_EMAIL_TIMESTAMP, conversation) || null;
};

exports.default = getLastActiveAt;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/conversation/getLastActiveAt.js
// module id = 874
// module chunks = 2 3